/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { StoreTypeForUserDto } from '../model/storeTypeForUserDto';
import { StoreTypeOutputDto } from '../model/storeTypeOutputDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
    providedIn:'root'
})
export class StoreTypeService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param cdStoreType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreTypeDeleteDelete(cdStoreType?: number, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiStoreTypeDeleteDelete(cdStoreType?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiStoreTypeDeleteDelete(cdStoreType?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiStoreTypeDeleteDelete(cdStoreType?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdStoreType !== undefined && cdStoreType !== null) {
            queryParameters = queryParameters.set('cdStoreType', <any>cdStoreType);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('delete',`${this.basePath}/api/StoreType/Delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStoreType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreTypeGetByIdGet(cdStoreType: number, observe?: 'body', reportProgress?: boolean): Observable<StoreTypeOutputDto>;
    public apiStoreTypeGetByIdGet(cdStoreType: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoreTypeOutputDto>>;
    public apiStoreTypeGetByIdGet(cdStoreType: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoreTypeOutputDto>>;
    public apiStoreTypeGetByIdGet(cdStoreType: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cdStoreType === null || cdStoreType === undefined) {
            throw new Error('Required parameter cdStoreType was null or undefined when calling apiStoreTypeGetByIdGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdStoreType !== undefined && cdStoreType !== null) {
            queryParameters = queryParameters.set('cdStoreType', <any>cdStoreType);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StoreTypeOutputDto>('get',`${this.basePath}/api/StoreType/GetById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreTypeGetGet(observe?: 'body', reportProgress?: boolean): Observable<Array<StoreTypeOutputDto>>;
    public apiStoreTypeGetGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<StoreTypeOutputDto>>>;
    public apiStoreTypeGetGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<StoreTypeOutputDto>>>;
    public apiStoreTypeGetGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<StoreTypeOutputDto>>('get',`${this.basePath}/api/StoreType/Get`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param dsName 
     * @param dsDescription 
     * @param isEnabled 
     * @param dsImage 
     * @param itemImage 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreTypePostPostForm(dsName?: string, dsDescription?: string, isEnabled?: boolean, dsImage?: string, itemImage?: Blob, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public apiStoreTypePostPostForm(dsName?: string, dsDescription?: string, isEnabled?: boolean, dsImage?: string, itemImage?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public apiStoreTypePostPostForm(dsName?: string, dsDescription?: string, isEnabled?: boolean, dsImage?: string, itemImage?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public apiStoreTypePostPostForm(dsName?: string, dsDescription?: string, isEnabled?: boolean, dsImage?: string, itemImage?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (dsName !== undefined) {
            formParams = formParams.append('DsName', <any>dsName) as any || formParams;
        }
        if (dsDescription !== undefined) {
            formParams = formParams.append('DsDescription', <any>dsDescription) as any || formParams;
        }
        if (isEnabled !== undefined) {
            formParams = formParams.append('IsEnabled', <any>isEnabled) as any || formParams;
        }
        if (dsImage !== undefined) {
            formParams = formParams.append('DsImage', <any>dsImage) as any || formParams;
        }
        if (itemImage !== undefined) {
            formParams = formParams.append('ItemImage', <any>itemImage) as any || formParams;
        }

        return this.httpClient.request<number>('post',`${this.basePath}/api/StoreType/Post`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStoreType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreTypePutDisablePut(cdStoreType?: number, observe?: 'body', reportProgress?: boolean): Observable<StoreTypeOutputDto>;
    public apiStoreTypePutDisablePut(cdStoreType?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoreTypeOutputDto>>;
    public apiStoreTypePutDisablePut(cdStoreType?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoreTypeOutputDto>>;
    public apiStoreTypePutDisablePut(cdStoreType?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdStoreType !== undefined && cdStoreType !== null) {
            queryParameters = queryParameters.set('cdStoreType', <any>cdStoreType);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StoreTypeOutputDto>('put',`${this.basePath}/api/StoreType/PutDisable`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStoreType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreTypePutEnablePut(cdStoreType?: number, observe?: 'body', reportProgress?: boolean): Observable<StoreTypeOutputDto>;
    public apiStoreTypePutEnablePut(cdStoreType?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoreTypeOutputDto>>;
    public apiStoreTypePutEnablePut(cdStoreType?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoreTypeOutputDto>>;
    public apiStoreTypePutEnablePut(cdStoreType?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdStoreType !== undefined && cdStoreType !== null) {
            queryParameters = queryParameters.set('cdStoreType', <any>cdStoreType);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StoreTypeOutputDto>('put',`${this.basePath}/api/StoreType/PutEnable`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStoreType 
     * @param dsName 
     * @param dsDescription 
     * @param isEnabled 
     * @param dsNewImage 
     * @param itemImage 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreTypePutPutForm(cdStoreType?: number, dsName?: string, dsDescription?: string, isEnabled?: boolean, dsNewImage?: string, itemImage?: Blob, observe?: 'body', reportProgress?: boolean): Observable<StoreTypeOutputDto>;
    public apiStoreTypePutPutForm(cdStoreType?: number, dsName?: string, dsDescription?: string, isEnabled?: boolean, dsNewImage?: string, itemImage?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoreTypeOutputDto>>;
    public apiStoreTypePutPutForm(cdStoreType?: number, dsName?: string, dsDescription?: string, isEnabled?: boolean, dsNewImage?: string, itemImage?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoreTypeOutputDto>>;
    public apiStoreTypePutPutForm(cdStoreType?: number, dsName?: string, dsDescription?: string, isEnabled?: boolean, dsNewImage?: string, itemImage?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (cdStoreType !== undefined) {
            formParams = formParams.append('CdStoreType', <any>cdStoreType) as any || formParams;
        }
        if (dsName !== undefined) {
            formParams = formParams.append('DsName', <any>dsName) as any || formParams;
        }
        if (dsDescription !== undefined) {
            formParams = formParams.append('DsDescription', <any>dsDescription) as any || formParams;
        }
        if (isEnabled !== undefined) {
            formParams = formParams.append('IsEnabled', <any>isEnabled) as any || formParams;
        }
        if (dsNewImage !== undefined) {
            formParams = formParams.append('DsNewImage', <any>dsNewImage) as any || formParams;
        }
        if (itemImage !== undefined) {
            formParams = formParams.append('ItemImage', <any>itemImage) as any || formParams;
        }

        return this.httpClient.request<StoreTypeOutputDto>('put',`${this.basePath}/api/StoreType/Put`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdCity 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreTypeStoreTypesInCityGet(cdCity?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<StoreTypeForUserDto>>;
    public apiStoreTypeStoreTypesInCityGet(cdCity?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<StoreTypeForUserDto>>>;
    public apiStoreTypeStoreTypesInCityGet(cdCity?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<StoreTypeForUserDto>>>;
    public apiStoreTypeStoreTypesInCityGet(cdCity?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdCity !== undefined && cdCity !== null) {
            queryParameters = queryParameters.set('cdCity', <any>cdCity);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<StoreTypeForUserDto>>('get',`${this.basePath}/api/StoreType/StoreTypesInCity`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
